import moment from 'moment'
import apollo from '@/graphql'

import PogDetailsQuery from '@/graphql/pog/PogDetailsQuery.gql'
import PogApplicableCompaniesQuery from '@/graphql/pog/PogApplicableCompaniesQuery.gql'
import SavePogDetails from '@/graphql/pog/SavePogDetails.gql'

// inital state
const state = {
  editablePogFields: {},
  pogApplicableCompanies: [],
  pogCsv: null,
  pogDetails: {},
  pogImage: null,
}

// getters
const getters = {
  editablePogFields: st => st.editablePogFields,
  pogApplicableCompanies: st => st.pogApplicableCompanies,
  pogCsv: st => st.pogCsv,
  pogDetails: st => st.pogDetails,
  pogImage: st => st.pogImage,
}

// mutations
const mutations = {
  createPogDetails() {
    state.editablePogFields = { retailersId: null }
    state.pogCsv = null
    state.pogDetails = { name: 'New Pog' }
    state.pogImage = null
  },

  setEditablePogFields(st, pogDetails) {
    state.editablePogFields = {
      deactivateDate: !pogDetails.deactivateDate
        ? ''
        : moment.utc(parseInt(pogDetails.deactivateDate, 10)).format('YYYY-MM-DD'),
      effectiveDate: !pogDetails.effectiveDate
        ? ''
        : moment.utc(parseInt(pogDetails.effectiveDate, 10)).format('YYYY-MM-DD'),
      id: pogDetails.id,
      name: pogDetails.name,
      rackTypesId: pogDetails.rackTypesId,
      retailersId: pogDetails.retailersId,
    }
  },

  setPogApplicableCompanies(st, companies) {
    state.pogApplicableCompanies = companies
  },

  setPogCsv(st, { file }) {
    state.pogCsv = file
  },

  setPogDetails(st, pogDetails) {
    state.pogDetails = pogDetails
  },

  setPogImage(st, { file }) {
    state.pogImage = file
  },
}

// actions
const actions = {

  loadPogApplicableCompanies({ commit }) {
    apollo.defaultClient
      .watchQuery({
        query: PogApplicableCompaniesQuery,
      })
      .subscribe(({ data: { wholesalers, retailers } }) => {
        commit('setPogApplicableCompanies', wholesalers.concat(retailers))
      })
  },

  loadPogDetails({ commit }, { id }) {
    apollo.defaultClient
      .watchQuery({
        query: PogDetailsQuery,
        variables: { id: +id },
      })
      .subscribe(({ data: { pogDetails } }) => {
        commit('setEditablePogFields', pogDetails)
        commit('setPogDetails', pogDetails)
      })
  },

  savePogDetails(context, { $message, $router }) {
    apollo.defaultClient
      .mutate({
        mutation: SavePogDetails,
        variables: {
          csv: state.pogCsv,
          fields: state.editablePogFields,
          image: state.pogImage,
        },
        refetchQueries: [state.pogDetails.id].filter(id => id).map(id => ({
          query: PogDetailsQuery,
          variables: { id: +id },
        })),
      })
      .then(({ data: { savePogDetails: { id } } }) => {
        $message({ message: 'Changes saved', type: 'success' })
        $router.push(`/pog/${id}`)
      })
  },

  uploadPogCsv({ commit }, { file }) {
    commit('setPogCsv', { file })
  },

  uploadPogImage({ commit }, { file }) {
    commit('setPogImage', { file })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/pog/PogDetails.js